// Komt uit de build (REACT_APP_API_ENDPOINT, gezet in .gitlab-ci.yml); lokaal: zet hem in .env.local.
const APIENDPOINT = process.env.REACT_APP_API_ENDPOINT || "http://127.0.0.1:8000/api";
export default APIENDPOINT;
